import React, { Component } from 'react';

class OmattiedotDialog extends Component {
  constructor(props){
    super(props);
    this.state = {omatTiedot:{}};
    this.handleTallennaOmattiedot = this.handleTallennaOmattiedot.bind(this);

    this.handleOmatiedoFieldChange = this.handleOmatiedoFieldChange.bind(this);
  }

  componentWillReceiveProps(){
  //  this.setState({valittuTyo: this.props.valittuTyo});
  }
  handleTallennaOmattiedot(){
    let omatTiedot = this.state.omatTiedot;
    if(omatTiedot.password1 != omatTiedot.password2){
        this.props.showNotification("Salasanat eivät vastaa toisiaan!");
    }else{
        this.props.changePassword(omatTiedot.password0,omatTiedot.password1);
    }
  }
  handleOmatiedoFieldChange(evt){
    let inputId =  evt.target.id;

      let omatTiedot = this.state.omatTiedot;
    omatTiedot[inputId] =  evt.target.value;
    this.setState({omatTiedot:omatTiedot});


  }
  render() {

    return (

        <div className="addWorkerView">

     <h1>Omien tietojen muokkaus</h1>
     <form>

   <label  for="password0"><span>Vanha salasana</span>
   <input type="password" class="form-input password" id="password0"   onChange={this.handleOmatiedoFieldChange} /></label>


   <label  for="password1"><span>Uusi salasana</span>
   <input type="password" class="form-input password" id="password1"    onChange={this.handleOmatiedoFieldChange} /></label>
 

   <label className="form-label password-label" for="password2"><span>Uusi salasana uudelleen</span>
   <input type="password" class="form-input password" id="password2"      onChange={this.handleOmatiedoFieldChange} /></label>

 




  <button className="btnSecondButton" onClick={this.handleTallennaOmattiedot}>Tallenna</button>
  
  <button className="btnClose" onClick={this.props.changeToEmployeesView}>Sulje</button>
  </form>
 </div>
        )
  }




};
export default OmattiedotDialog;
